export class CustomerFeeScheduleDTO{
    public id!: number;
    public customerId!: number;
    public billingTypeCode!: string;
    public amount!: number;
    public discountSchedule!: string;
    public added!: string;
    public edited!: string;
}